<template>
  <div class="container block-form" style="max-width: 1000px;">
    <div class="my-4">

      <h5 style="margin-left: -20px;">
        <span @click="$parent.on_step = 'init'" class="cp">
          <i class="fas fa-arrow-left"></i>
          {{lg('',{
            en: 'Manage collectible type',
            zh: '铸造NFT类型',
          })}}
        </span>
      </h5>
    </div>

    <h3>
      <span v-if="is_type_multi">
        {{lg('',{
          en: 'Create Multiple Collectible',
          zh: '铸造多个NFT',
        })}}
      </span>
      <span v-else>
        {{lg('',{
          en: 'Create Single Collectible',
          zh: '铸造单个NFT',
        })}}
      </span>
    </h3>

    <div :class="['form-flex d-flex flex-wrap pt-4',{'fx-loading': status_creating}]">

      <!-- 右侧预览 -->
      <div class="box-preview mb-5">
        <h4 class="mb-4">
          {{lg('',{
            en: 'Preview',
            zh: '预览',
          })}}
        </h4>
        <div 
          class="pic-box py-4 d-flex justify-content-center align-items-center" 
          style="border: 1px solid #ddd; border-radius: 40px; max-width: 100%;"
          >
            <span 
              v-if="!sync_file.img_url"
              class="text-muted"
              >
              {{lg('',{
                en: 'Prevlew of your new collectible',
                zh: 'NFT预览',
              })}}
            </span>

            <div class="pic-holder" style="background: transparent;">
              <CpNftCoverImg
                :src="sync_file.img_url"
              />
            </div>
            
        </div>
      </div>

      <!-- 左侧表单 -->
      <div class="box-form pb-5">

        <!--  -->
        <div class="mb-4">
          <h4>
            {{lg('',{
              en: 'Upload file:',
              zh: '上传文件',
            })}}
          </h4>

          <div 
            class="p-4 mt-4 mb-5 tac"
            style="border: 2px dashed #ddd; border-radius: 40px;"
            >
            <label class="my-3">

              <span class="btn btn-primary round">
                {{lg('',{
                  en: 'Choose file',
                  zh: '选择文件',
                })}}
                <span v-if="sync_file.status_uploading">...</span>
              </span>

              <CpUniUpload
                class="none"
                :sync_obj="sync_file"
                :conf="{
                  target_folder_name: 'create/',
                  filetype_allowed: ['jpg','jpeg','png','webp','gif','mp3','mp4'],
                  compress_cfg: {
                    maxWidth: 3500,
                    maxHeight: 3500,
                  },
                  max_size: 30,
                }"
              />
            </label>

            <div class="text-muted">
              {{lg('',{
                en: 'PNG, GIF, WEBP, MP4 or MP3. Max 30mb',
                zh: 'PNG, JPEG, GIF, WEBP, MP3 或 Mp4, 最大 30MB',
              })}}
            </div>
            
          </div>
        </div>

        <!-- Put on sale -->
        <div class="my-4">
          <div class="d-flex justify-content-between">
            <div>
              <h4>
                {{lg('',{
                  en: 'Put on sale',
                  zh: '马上出售',
                })}}
              </h4>
              <div class="text-muted">
                {{lg('',{
                  en: 'You’ll receive bids on this item',
                  zh: '您将收到关于此商品的竞标',
                })}}
              </div>
            </div>

            <label class="btn-switch-label">
              <input 
                v-model="mark_sale_now"
                type="checkbox"
              >
              <span :class="['btn-switch']"></span>
            </label>

          </div>
        </div>
        
        <!-- price for sell -->
        <div class="my-4" v-if="mark_sale_now">
          <h4>
            {{lg('',{
              en: 'Instant sale price',
              zh: '出售价格',
            })}}
          </h4>
          <div class="text-muted">
            {{lg('',{
              en: 'Enter the price for which the item will be instantly sold',
              zh: '请输入该商品的出售价格',
            })}}
          </div>
          <div class="d-flex mb-3">
            <input 
              v-model.number="cfg_price.num_price_sell" 
              type="text" 
              class="form-control"
            >
            <select 
              class="form-control ml-3"
              style="width: 100px;"
              v-model="cfg_price.token_id_sell"
              >
              <option 
                v-for="(item,index) of $store.state.fecfg.cfg_token_type_sell"
                :key="index"
                :value="item.id"
                style="height: 2em;"
                >
                {{item.name}}
              </option>
            </select>
          </div>
        </div>

        <!-- Unlock once purchased -->
        <div v-if="0" class="my-4">
          <div class="d-flex justify-content-between">
            <div>
              <h4>
                {{lg('',{
                  en: 'Unlock once purchased',
                  zh: '',
                })}}
              </h4>
              <div class="text-muted">
                {{lg('',{
                  en: 'Content will be unlocked after successful transaction',
                  zh: '',
                })}}
              </div>
            </div>

            <label class="btn-switch-label">
              <input type="checkbox">
              <span :class="['btn-switch']"></span>
            </label>

          </div>
        </div>

        <!-- Choose collection -->
        <div class="my-4">
          <h4>
            {{lg('',{
              en: 'Choose collection',
              zh: '选择NFT类型',
            })}}
          </h4>

          <div class="mt-3 d-flex">

            <div 
              class="cp border tac bg-light d-flex flex-column align-items-center justify-content-center" 
              style="width: 100px; height: 100px;border-radius: 20px;"
              >
              <img src="/static/pic/site_symb.png" style="width: 50px;height: 50px;">
              <span class="b small">
                JGNNFT
              </span>
            </div>

          </div>
        </div>

        <!-- name -->
        <div class="my-4">
          <h4>
            {{lg('',{
              en: 'Name',
              zh: '名字',
            })}}
          </h4>
          <div class="mt-3">
            <input 
              v-model="form.name"
              type="text" 
              class="form-control"
              :placeholder="lg('',{
                en: 'e.g. “redeemable Cards with logo”',
                zh: '',
              })"
            >
          </div>
        </div>

        <!-- Description -->
        <div class="my-4">
          <h4>
            {{lg('',{
              en: 'Description',
              zh: '简介',
            })}}

            <span class="small t-gray">
              {{lg('',{
                en: '(Optional)',
                zh: '(非必填)',
              })}}
            </span>
          </h4>
          <div class="mt-3">
            <input 
              v-model="form.description"
              type="text" 
              class="form-control"
              :placeholder="lg('',{
                en: 'e.g. “After purchasing you’ll able to get real cards”',
                zh: '',
              })"
            >
          </div>
        </div>

        <!-- 2个属性 -->
        <div class="d-flex">
          <div class="w-100">
            <!-- Royalties -->
            <div class="my-4">
              <h4>
                {{lg('',{
                  en: 'Royalties',
                  zh: '版税',
                })}}
              </h4>
              <div class="mt-3 rel">
                <input 
                  v-model.number="form_b.royalties"
                  type="text" 
                  class="form-control"
                  :placeholder="lg('',{
                    en: 'e.g. 10%',
                    zh: '',
                  })"
                >
                <span class="t-gray abs" style="top: 5px; right: 10px;">
                  %
                </span>
                <span class="small t-gray">
                  {{lg('',{
                    en: 'Suggested: 10%, 20%, 30%',
                    zh: '建议: 10%, 20%, 30%',
                  })}}
                </span>
              </div>
            </div>
          </div>
          <div v-if="is_type_multi" class="w-100 ml-3">
            <!-- Number of copies -->
            <div class="my-4">
              <h4>
                {{lg('',{
                  en: 'Number of copies',
                  zh: '数量',
                })}}
              </h4>
              <div class="mt-3">
                <input 
                  v-model.number="form_b.max_supply"
                  type="text" 
                  class="form-control"
                  :placeholder="lg('',{
                    en: 'e.g. 10',
                    zh: '',
                  })"
                >
                <span class="small t-gray">
                  {{lg('',{
                    en: 'Amount of tokens',
                    zh: 'NFT数量',
                  })}}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Properties -->
        <div class="my-4">
          <h4>
            {{lg('',{
              en: 'Properties',
              zh: '属性',
            })}}

            <span class="small t-gray">
              {{lg('',{
                en: '(Optional)',
                zh: '(非必填)',
              })}}
            </span>
          </h4>
          <div class="mt-3">
            <div 
              v-for="(item,index) of arr_attr" 
              class="d-flex mb-2"
              :key="index"
              >

              <input 
                v-model="item.trait_type"
                type="text" 
                class="form-control"
                :placeholder="lg('',{
                  en: 'e.g. Size',
                  zh: '',
                })"
              >

              <input 
                v-model="item.value"
                type="text" 
                class="form-control ml-3"
                :placeholder="lg('',{
                  en: 'e.g. M',
                  zh: '',
                })"
              >
            </div>

          </div>
        </div>

        <div class="my-5">

          <button @click="btnCreate()" class="btn btn-primary px-4">
            {{lg('',{
              en: 'Create Now',
              zh: '立刻铸造',
            })}}
            <span v-if="status_creating">
              ...
            </span>
          </button>
        </div>

        <!-- dev 测试辅助部分 -->
        <div v-if="0" class="mt-5">
          <button @click="testSell()" class="btn btn-primary">
            触发sell 1-1
            <span v-if="status_creating">
              ...
            </span>
          </button>
        </div>

      </div>
    </div>

    <!-- sell -->
    <popSell
      :cfg_status_poppad="cfg_status_poppad_sell"
      :item="item"
      :meta_item="meta_item"
      :cfg_price="cfg_price"
    />

    <UiModal class="sp-loading-modal" :open="status_creating || status_loading_to_sell">
      <div class="tac pt-5 pb-4">
        <span 
          class="ui-loading-icon size-sm"
        ></span>
        <h5 class="mt-4">
          <div v-if="status_loading_to_sell">
            {{lg('',{
              en: 'Created & Loading to sell...',
              zh: '铸造成功，即将卖出...',
            })}}
          </div>
          <div v-else>
            {{lg('',{
              en: 'Creating...',
              zh: '铸造中...',
            })}}
          </div>
        </h5>
      </div>
    </UiModal>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import popSell from '../detail/pop_sell.vue'

export default {
  name: 'createForm',
  components: {
    popSell,
  },
  props: [],
  data() {
    return {

      // 
      status_loading_to_sell: false,
      
      // 
      meta_item: {},
      item: {},
      cfg_status_poppad_sell: false,
      
      // 
      status_creating: false,
      mark_sale_now: true,

      cfg_price: {
        num_price_sell: '',
        token_id_sell: 'eth',
      },

      sync_file: {
        img_url: '',
        status_uploading: false,
        status_upload_percent: 0,
      },

      // 
      form: {
        "name":"",
        "description":"",
      },
      form_b: {
        royalties: 10,
        max_supply: 1,
      },
      template_attr: {"trait_type":"","value":""},
      arr_attr: [
        {"trait_type":"","value":""},
      ],

      // 
      res_btn_create: {},
    }
  },

  computed: {
    is_type_multi(){
      let mark = false
      if(this.$parent.form_cfg_single_or_multi == 'multi'){
        mark = true
      }
      return mark
    },
    calc_form(){
      let v = this
      
      let obj = {}
      obj.name = v.form.name
      obj.image = v.sync_file.img_url

      let nft_info = {}

      let temp_arr = []
      temp_arr.push({
        'trait_type': 'Royalties',
        'value': v.form_b.royalties + '%',
      })
      temp_arr.push({
        'trait_type': 'Max Supply',
        'value': v.form_b.max_supply,
      })
      temp_arr = temp_arr.concat(
        v.arr_attr.filter(item => {
          return (item.trait_type && item.value)
        })
      )
      nft_info.attributes = temp_arr

      nft_info.name = v.form.name
      nft_info.image = v.sync_file.img_url
      nft_info.description = v.form.description

      obj.nft_info = JSON.stringify(nft_info)

      return obj
    },
  },
  watch: {
    arr_attr: {
      deep: true,
      handler(arr){
        let v = this

        // 删除空白项
        // for(let i = 1; i<= arr.length -2; i++){
        //   if(!arr[i].trait_type && !arr[i].value){
        //     console.log(i)
        //     arr.splice(i)
        //   }
        // }

        // 末尾新增1项
        let last = arr[arr.length - 1]
        if(last.trait_type && last.value){
          arr.push(
            JSON.parse(JSON.stringify(v.template_attr))
          )
        }
      },
    },

    'form_b.royalties'(){
      let v = this
      if(!v.form_b.royalties){
        return
      }
      if(typeof v.form_b.royalties !== 'number'){
        v.form_b.royalties = ''
        return
      }

      v.form_b.royalties = parseFloat(parseFloat(v.form_b.royalties).toFixed(2))

      if(v.form_b.royalties >= 100 || v.form_b.royalties <= 0){
        v.form_b.royalties = ''
      }
    },
  },
  methods: {

    ...mapActions([
      'NFT1155Mint',
      'NFT721Mint',
    ]),

    btnToggleSell(){
      let v = this
      v.cfg_status_poppad_sell = !v.cfg_status_poppad_sell

      // sell 弹框如果关闭，则关闭表单
      if(!v.cfg_status_poppad_sell){
        this.$parent.on_step = 'init'
      }
    },
    
    btnCreate(){
      let v = this

      if( !v.$store.state.web3.account){
        return
      }

      if( !v.form.name || (!v.form_b.royalties && v.form_b.royalties !== 0 ) || !v.form_b.max_supply){
        alert('Please fill Name, Royalties, and Number of Copies.')
        return
      }

      let api_str = 'create_item_single'
      if(v.is_type_multi){
        api_str = 'create_item_multi'
      }
      v.api(api_str,v.calc_form,{
        vue: v,
        key_ajaxing: 'status_creating',
        key_data: 'res_btn_create',
        done_run_function: 'chainCreate',
      })
    },

    async chainCreate(){
      let v = this

      let fn_str = 'NFT721Mint'
      if(v.is_type_multi){
        fn_str = 'NFT1155Mint'
      }

      let form = {
        address: v.$store.state.web3.account,
        Royalties: v.form_b.royalties,
        supply: v.form_b.max_supply,
        NFT_ID: v.res_btn_create.nft_id,
        uri: v.res_btn_create.url,

        callback: function() {
          // 调用sell弹框
          v.status_creating = false
          if(v.mark_sale_now){
            v.getDataAndShowSellPop()
          }else{
            v.$parent.on_step = 'init'
          }
        },

        callbackOnErr: function() {
          v.status_creating = false
        },
      }

      v.status_creating = true
      await v[fn_str](form)
      // v.status_creating = false
    },

    wait(ms) {
      return new Promise((resolve) => {
        setTimeout(() => {
          console.log("Done waiting "+ms);
          resolve(ms)
        }, ms)
      })
    },
    
    async getDataAndShowSellPop(){
      let v = this

      // 延迟
      v.status_loading_to_sell = true
      console.log( (new Date()).toLocaleString() )
      await v.wait(15000)
      console.log( (new Date()).toLocaleString() )

      let nft_address = v.$store.state.web3['nft_address_single']
      if(v.is_type_multi){
        nft_address = v.$store.state.web3['nft_address_multi']
      }
      
      let res = await v.api('query_item_detail',{
        'address': v.$store.state.web3.account || '',
        'nft_address': nft_address,
        'nft_id': v.res_btn_create.nft_id,
        'owner': v.$store.state.web3.account,
      })

      if(res.code == 0){
        if(!res.data.owner_info){
          res.data.owner_info = {}
        }
        v.meta_item = res.data
      }

      // meme data
      v.item = await v.uniFetchItemInfo(v.meta_item)
      v.status_loading_to_sell = false

      // 显示弹框
      this.btnToggleSell()
    },

    testSell(){
      let v = this
      v.res_btn_create = {
        nft_id: 1, 
        url: "1"
      }

      v.getDataAndShowSellPop()
    },
  },
  created() {
    if(this.is_type_multi){
      this.form_b.max_supply = ''
    }
    return
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  .block-form{

    /deep/ .sp-loading-modal{
      .shell{
        max-width: 280px;
      }
      .iconclose{
        display: none !important;
      }
    }

    input,select{
      border-radius: 0;
      border-top: none;
      border-left: none;
      border-right: none;
      &:focus{
        border-bottom-color: #999;
      }
    }

    .fx-loading{
      position: relative;
      &::before{
        z-index: 1;
        content: ' ';
        background-color: rgba(255,255,255,0.7);
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
      }
    }

    h4{
      font-size: 20px;
    }
    @media(min-width: 788px){
      .box-preview{
        margin-left: 50px;
        order: 2;
        .pic-box{
          width: 300px;
          height: 400px;
        }
      }

    }

    @media(max-width: 788px){
      .form-flex{
        flex-direction: column;
      }
      .box-preview{
        font-size: 12px;

        .pic-box{
          min-height: 140px;
        }
      }
    }

    // @media(min-width: 788px){
    //   .box-preview{
    //   }
    // }
  }
</style>